import { Component, inject, OnInit, OnDestroy } from '@angular/core';
import { finalize, tap } from 'rxjs';
import { CountdownService, ISeoTagType, SEOService } from '@app/shared/services';
import { BookingCompletedVisitDetailsDirective } from '@app/booking-part/booking-completed/booking-completed-summary/booking-completed-visit-details.directive';

@Component({
  selector: 'app-payment-pending',
  templateUrl: './payment-pending.component.html',
  styleUrls: ['./payment-pending.component.scss']
})

export class PaymentPendingComponent extends BookingCompletedVisitDetailsDirective implements OnInit, OnDestroy {
  public countdownRedirectInSeconds = 2;
  private seoService = inject(SEOService);
  private countdown = inject(CountdownService);

  constructor() {
    super();
    this.setSEO();
  }

  ngOnInit(): void {
    super.ngOnInit();

    if (!this.visitDetails) {
      return;
    }

    this.countdown.getSecondsCountdown$(this.countdownRedirectInSeconds)
      .pipe(
        tap((remainingSeconds: number) => this.countdownRedirectInSeconds = remainingSeconds),
        finalize(() => this.goToPayment()))
      .subscribe();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  public goToPayment(): void {
    const paymentUrl = this.getPaymentUrl();
    window.location.replace(paymentUrl);
  }

  private getPaymentUrl(): string {
    const paymentUrl = this.paymentUrl;
    const salonId = `salonId=${this.visitDetails.salonId}`;
    const visitId = `visitId=${this.visitDetails.visitId}`;
    const returnUrl = `returnUrl=${this.constructReturnUrl()}`;
    const completePaymentUrl = `${paymentUrl}?${salonId}&${visitId}&${returnUrl}`;
    return completePaymentUrl;
  }

  private constructReturnUrl(): string {
    const start = `${location.origin}/salon`;
    let mid = `/${this.visitDetails.salonCity}/${this.visitDetails.salonNameAlias}`;
    const end = `/${this.visitDetails.visitId}/booking-completed?accountCreated=${this.accountCreated}`;
    if (this.isRouteBySalonId) {
      mid = `/${this.visitDetails.salonId}`;
    }
    return `${start}${mid}${end}`;
  }

  private setSEO(): void {
    this.seoService.setSEO([
      {
        tagType: ISeoTagType.Title,
        i18nKey: 'BOOKING-PART.PAYMENT-PENDING.META-TITLE'
      },
      {
        tagType: ISeoTagType.Description,
        i18nKey: 'BOOKING-PART.PAYMENT-PENDING.META-DESCRIPTION'
      }
    ]);
  }
}
